import type { GameEvent } from './types'

/**
 * Compares the player's order against the solution and returns, per slot,
 * whether the event in that slot is chronologically correct.
 *
 * Graded by date rather than id so that two events sharing the same calendar
 * date are interchangeable — the player can't be penalised for an order the
 * data itself can't distinguish.
 */
export function gradeOrder(order: GameEvent[], solution: GameEvent[]): boolean[] {
  return order.map((ev, i) => solution[i]?.date === ev.date)
}

export function countCorrect(grade: boolean[]): number {
  return grade.reduce((n, ok) => n + (ok ? 1 : 0), 0)
}

/** Builds the Wordle-style shareable text for a finished puzzle, ending with a play link. */
export function buildShareText(opts: {
  categoryName: string
  puzzleNumber: number
  checks: boolean[][]
  won: boolean
  maxAttempts: number
  url: string
}): string {
  const { categoryName, puzzleNumber, checks, won, maxAttempts, url } = opts
  const name = categoryName || 'Lineup'
  const score = won ? `${checks.length}/${maxAttempts}` : `X/${maxAttempts}`
  const grid = checks
    .map((row) => row.map((ok) => (ok ? '🟩' : '⬛')).join(''))
    .join('\n')
  return `Lineup ${name} #${puzzleNumber} ${score}\n\n${grid}\n\n${url}`
}

/** The canonical play link for a category, derived from the current page. */
export function sharePlayUrl(category: string): string {
  try {
    const { origin, pathname } = window.location
    return `${origin}${pathname}?cat=${category}`
  } catch {
    return `https://jrkb6.dev/lineup/?cat=${category}`
  }
}
